import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
  (theme) => ({
    wrapper: {
      position: 'relative',
      width: '100%'
    },
    legend: {
      marginTop: 0,
      marginBottom: 0,
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(6),
      paddingBottom: theme.spacing(2)
    },
    'delete-btn': {
      position: 'absolute',
      top: 0,
      right: 0
    }
  }),
  { name: 'email-fieldset-' }
)

export default useStyles
